import { useEffect, useCallback } from 'react'
import { useZustand } from '../../hooks/useZustand'

// This hook function listens for sentiment model updates from an analytics panel in the old EJS system.
// It updates the sentiment of statements based on the selected model
function useSentimentUpdate(label, username, isPublic) {
    const handleSentimentUpdate = useCallback(
        async (modelToUse, label, username) => {
            if (!username || !label) {
                return
            }
            if (modelToUse === 'bert' || modelToUse === 'google') {
                const sentiments = await useZustand
                    .getState()
                    .analyzeSentiments(username, modelToUse, [], isPublic)
                useZustand.getState().reassessSentiments(sentiments, modelToUse)
            } else if (modelToUse === 'wink') {
                const sentiments = useZustand.getState().sentimentCache[
                    modelToUse
                ]

                if (sentiments) {
                    useZustand
                        .getState()
                        .reassessSentiments(sentiments, modelToUse)
                }
            }

            analyticsPanel.analyzeSentiment(
                username,
                label,
                null,
                'recalculate',
                modelToUse
            )
        },
        [label, username]
    )

    useEffect(() => {
        const handleSentimentUpdateCallback = async sentimentModel => {
            await handleSentimentUpdate(sentimentModel, label, username)
        }
        if (window.myEventEmitter) {
            window.myEventEmitter.on(
                'sentimentUpdate',
                handleSentimentUpdateCallback
            )
        }

        return () => {
            if (window.myEventEmitter) {
                window.myEventEmitter.removeListener(
                    'sentimentUpdate',
                    handleSentimentUpdateCallback
                )
            }
        }
    }, [label, username])
}

export default useSentimentUpdate
